import Head from 'next/head';
import { buildCatalogPath } from '@/lib/productRoutes';
import { SEO_DEFAULTS, getAbsoluteImageUrl, getAbsoluteUrl } from '@/lib/seo';

const STORE_ID = getAbsoluteUrl('/#store');
const CONTACT_URL = getAbsoluteUrl('/contact');
const OFFER_CATALOG_ITEMS = [
  {
    name: 'Men Footwear',
    url: getAbsoluteUrl(buildCatalogPath({ department: 'Men' })),
  },
  {
    name: 'Women Footwear',
    url: getAbsoluteUrl(buildCatalogPath({ department: 'Women' })),
  },
  {
    name: 'Kids Footwear',
    url: getAbsoluteUrl(buildCatalogPath({ department: 'Kids' })),
  },
  {
    name: 'Clothes Collection',
    url: getAbsoluteUrl(buildCatalogPath({ department: 'Clothes' })),
  },
];

const LocalBusinessSchema = () => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'ShoeStore',
    '@id': STORE_ID,
    name: 'Trendy Quest Collection',
    description: 'Quality footwear for confident everyday living',
    url: getAbsoluteUrl('/'),
    image: getAbsoluteImageUrl(SEO_DEFAULTS.defaultImage),
    logo: getAbsoluteImageUrl('/logo-yatiky.png'),
    telephone: '+254717002340',
    email: 'pattohkarimi@gmail.com',
    priceRange: 'KES 1500-3000',
    currenciesAccepted: 'KES',
    paymentAccepted: ['M-Pesa', 'Cash on Delivery', 'Visa', 'Mastercard', 'Bank Transfer'],
    areaServed: {
      '@type': 'Country',
      name: 'Kenya',
    },
    hasMap:
      'https://www.google.com/maps/search/?api=1&query=Dubai+Merchant+Mall+Ronald+Ngala+Street+Shop+G18+Nairobi',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Dubai Merchant Mall, Ronald Ngala Street, First Floor, Shop G18',
      addressLocality: 'Nairobi',
      addressRegion: 'Nairobi County',
      postalCode: '00100',
      addressCountry: 'KE',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '-1.286389',
      longitude: '36.817223',
    },
    contactPoint: [
      {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        telephone: '+254717002340',
        email: 'pattohkarimi@gmail.com',
        areaServed: 'KE',
        availableLanguage: ['en', 'sw'],
        url: CONTACT_URL,
      },
    ],
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: [
          'https://schema.org/Monday',
          'https://schema.org/Tuesday',
          'https://schema.org/Wednesday',
          'https://schema.org/Thursday',
          'https://schema.org/Friday',
          'https://schema.org/Saturday',
        ],
        opens: '09:00',
        closes: '19:00',
      },
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: 'https://schema.org/Sunday',
        opens: '10:00',
        closes: '17:00',
      },
    ],
    sameAs: SEO_DEFAULTS.socialProfiles,
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Trendy Quest Catalog',
      url: getAbsoluteUrl('/products'),
      itemListElement: OFFER_CATALOG_ITEMS.map((item) => ({
        '@type': 'OfferCatalog',
        name: item.name,
        url: item.url,
      })),
    },
  };

  return (
    <Head>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
    </Head>
  );
};

export default LocalBusinessSchema;
